Vue.component('categories', {
    template:'#categories-template',

    data:function(){
        return{
            list: [],
            subBrands: [],
            active_category:'',
            active_category_object:'',
            searchString:'',
            createBrandModal:'',
            editCategoryModal: '',
            editSubCategoryModal: ''
        };
    },

    created:function(){
        this.fetchData();
        Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('#csrf-token').getAttribute('value');
        categoryInstance = this;

        $(document).ready(function(){
            categoryInstance.editCategoryModal = $('#editCategoryModal').html();
            categoryInstance.editSubCategoryModal = $('#editSubCategoryModal').html();
            categoryInstance.createBrandModal = $('#createBrandModal').html();
            $('#editCategoryModal').remove();
        });
    },

    methods:{

        //FETCH DATA
        fetchData:function(){
            setTimeout(function(){
                var client_id = $('#content_wrapper').attr('data-id');
                categoryInstance.$http.get(baseURL+'/api/brand/list/all/'+client_id).then(function(response){
                    this.list = response.data;
                }).bind(this);
            },100);
        },
        fetchSubCategories:function(){
            console.log('fetching');
        },
        saveCategoryOrder:function(dataBlock){
            categoryInstance.$http.post(baseURL+'/admin/category/saveOrder',{'dataBlock':dataBlock}).then(function(response){

            }).bind(this);
        },
        saveSubCategoryOrder:function(dataBlock){
            categoryInstance.$http.post(baseURL+'/admin/subCategory/saveOrder',{'dataBlock':dataBlock}).then(function(response){

            }).bind(this);
        },

        //CHECK SUBCATEGORY DATA
        checkData:function(category){
            var id = category.id;
            var subCategories = category.subCategories;
            this.active_category=category.id;
            this.active_category_object=category;
            //console.log(category.subBrands);
            this.subBrands=category.subBrands;
            vm.$broadcast('updateSearchString',category.name);

        },
        //CREATE CATEGORY
        createCategory:function(){
            //console.log('test');

            bootbox.dialog({
                title: "Új márka hozzáadása",
                message: this.createBrandModal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            var client_id = activeInstance.client[0].id;
                            var brand_name =  $('.modal-dialog').find('#name').val();
                            var short_code =  $('.modal-dialog').find('#short_code').val();

                            if (brand_name.trim().length < 1) {
                                return false;
                            }

                            categoryInstance.$http.post(baseURL+'/admin/brand/add',{
                                client_id:client_id,
                                name: brand_name,
                                short_code:short_code
                            }).then(function(response){
                                successNotification('A márka sikeresen hozzáadva');
                                categoryInstance.fetchData();
                            });
                        }
                    }
                }
            });
        },
        filterCategory:function(name){
            vm.$broadcast('updateSearchString',name);
        },
        //EDIT CATEGORY NAME
        editCategory: function(category){

            bootbox.dialog({
                title: "Márka szerkesztése",
                message: this.editCategoryModal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            var category_name 				=  $('.modal-dialog').find('.category_name').val();
                            var short_code  				=  $('.modal-dialog').find('.short_code').val();

                            if (category_name.trim().length < 1) {
                                return false;
                            }

                            categoryInstance.$http.post(baseURL+'/admin/brand/update',{ id:category.id,name: category_name,short_code:short_code}).then(function(response){
                                categoryInstance.active_category_object.name = response.data.name;
                                categoryInstance.active_category_object.short_code = response.data.short_code;
                            });
                        }
                    }
                }
            });

            setTimeout(function(){
                $('.modal-dialog').find('.category_name').val(category.name);
                $('.modal-dialog').find('.short_code').val(category.short_code);
            },100)

        },
        //DELETE CATEGORY
        deleteCategory: function(brand){
            var confirm = bootbox.confirm('Biztosan el akarod távolítani ezt a brandet?', function(value){
                if(value===true){
                    showLoadingOverlay();
                    axios.post(baseURL+'/admin/brand/destroy',{
                        id:brand.id
                    })
                        .then(function(response){
                            $('body').LoadingOverlay("hide");
                            successNotification(response.data.message);
                            categoryInstance.list.$remove(brand);
                        })
                        .catch(function (error) {
                            $('body').LoadingOverlay("hide");
                            // Error
                            if (error.response) {
                                // The request was made and the server responded with a status code
                                // that falls out of the range of 2xx
                                // console.log(error.response.status);
                                // console.log(error.response.headers);
                                errorNotification(error.response.data.message);
                            } else if (error.request) {
                                // The request was made but no response was received
                                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                                // http.ClientRequest in node.js
                                console.log(error.request);
                            } else {
                                // Something happened in setting up the request that triggered an Error
                                console.log('Error', error.message);
                            }
                            //errorNotification(error.response.data.message);
                        })
                }
            });
        },


        /*=====  End of CATEGORIES  ======*/

        /*=====================================
        =            SUBCATEGORIES            =
        =====================================*/

        //CREATE SUBCATEGORY
        createSubCategory:function(){
            bootbox.prompt('Új almárka neve', function(value){
                if (value.trim().length < 1) {
                    return false;
                }
                activeInstance.$http.post(baseURL+'/admin/sub_brand/add',{name:value, id:categoryInstance.active_category}).then(function(response){
                    categoryInstance.fetchData();
                    categoryInstance.subBrands.push(response.data);
                }).bind(this);
            });
        },
        //DELETE SUBCATEGORY
        deleteSubCategory: function(subCategory){
            var confirm = bootbox.confirm('Biztosan el akarod távolítani az almárkát?', function(value){
                if(value===true){
                    activeInstance.$http.post(baseURL+'/admin/sub_brand/destroy', {id:subCategory.id}).then(function(response){
                        categoryInstance.subBrands.$remove(subCategory);
                    }).bind(this);
                }
            });
        },
        //EDIT SUBCATEGORY NAME
        editSubCategory: function(subCategory){
            bootbox.dialog({

                title: "Almárka szerkesztése",
                message: this.editSubCategoryModal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            var category_name 				=  $('.modal-dialog').find('.category_name').val();

                            if (category_name.trim().length < 1) {
                                return false;
                            }

                            var portionType = $('.modal-dialog').find('#portion-type-modal').val();
                            categoryInstance.$http.post(baseURL+'/admin/sub_brand/update',{
                                id:subCategory.id,
                                name: category_name
                            }).then(function(response){
                                subCategory.name = response.data.name;
                            });
                        }
                    }
                }

            });

//
            setTimeout(function(){

                $('.modal-dialog').find('.category_name').val(subCategory.name);
                $('.modal-dialog').find('.category_machine_name').val(subCategory.machineName);
                if(subCategory.enabled == true){
                    $('.modal-dialog').find('.category_public').prop('checked',true);
                }else
                {
                    $('.modal-dialog').find('.category_public').prop('checked',false);
                }

                if(subCategory.archive == true){
                    $('.modal-dialog').find('.category_archive').prop('checked',true);
                }else
                {
                    $('.modal-dialog').find('.category_archive').prop('checked',false);
                }

            },100)
        },

        /*=====  End of SUBCATEGORIES  ======*/
    }
});